"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PixelApi = void 0;
const SetPixelsMessage_1 = require("./messages/SetPixelsMessage");
const ControlMessage_1 = require("./messages/ControlMessage");
const PixelMap_1 = require("./PixelMap");
class PixelApi {
    constructor(configuration) {
        this._config = configuration;
    }
    clear() {
        return __awaiter(this, void 0, void 0, function* () {
            const clearMessage = ControlMessage_1.ControlMessage.clear();
            this._config.deviceAdapter.sendControlMessage(clearMessage);
        });
    }
    set(locations) {
        return __awaiter(this, void 0, void 0, function* () {
            const asArray = Array.isArray(locations) ? locations : [locations];
            const asMessage = SetPixelsMessage_1.SetPixelsMessage.fromPixelValueCollection(asArray);
            this._config.deviceAdapter.sendPixels(asMessage);
        });
    }
    setAll(pixelMap, color, clearEmpty = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const coords = [];
            const removeCoords = [];
            for (let item of PixelMap_1.PixelMap.itemsIn(pixelMap)) {
                if (item.data !== " ") {
                    coords.push(Object.assign(Object.assign({}, item), { color }));
                }
                if (clearEmpty && item.data === " ") {
                    removeCoords.push(Object.assign(Object.assign({}, item), { color: "#000000" }));
                }
            }
            const allPixels = [...coords, ...removeCoords];
            yield this.set(allPixels);
        });
    }
}
exports.PixelApi = PixelApi;
//# sourceMappingURL=PixelApi.js.map